import * as NS from './namespace';
import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { IUser } from '@/model/security';


//#region Реализации

// попытаемся извлеч пользователя и токен из локального хранилища
let user: IUser | undefined = undefined;
const token: string = localStorage.getItem('user-token') || '';

try {
    user = JSON.parse(localStorage.getItem('user-obj') as string) as IUser;
} catch (ex) {
    // очевидно юзера в хранилище нет
}

/**
 * Состояние по умолчанию модуля авторизации
 */
const defaultState: NS.IAuthState = {
    activeFormRequest: false,
    failedFormRequest: false,
    token: token,
    user: user,
};

//#endregion Реализации

/**
 * Модуль авторизации для хранилища
 */
export const AuthModule: Module<NS.IAuthState, NS.IAuthState> = {
    namespaced: true,
    actions: {
        ...actions,
    },
    getters: {
        ...getters,
    },
    mutations: {
        ...mutations,
    },
    state: {
        ...defaultState,
    },
};